export default "__VITE_ASSET__BpkZFh4E__"